import React from 'react'
import LinesEllipsis from 'react-lines-ellipsis'
import L from 'leaflet'
import {
  Map,
  TileLayer,
  LayersControl,
  Marker
} from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import './../assets/mapStyle.css'
import mapMarker from '../images/mapMarker.png'
import { STATUS_BY_VEHICLE_UPDATED } from '../query/trackable'
import { ApolloClient } from 'apollo-client'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { split } from 'apollo-link'
// import absintheSocketLink from '../graphql/AbsintheSocketLink'
import omegaAbsintheSocketLink from '../graphql/OmegaAbsintheSocketLink'
import config from '../config'
import { HttpLink } from 'apollo-link-http'
import { getMainDefinition } from 'apollo-utilities'
import { setContext } from 'apollo-link-context'

const httpLink = new HttpLink({
  uri: config.omega_graphql_api
})

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('token')
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : ''
    }
  }
})

const link = split(
  ({ query }) => {
    const definition = getMainDefinition(query)
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    )
  },
  omegaAbsintheSocketLink,
  authLink.concat(httpLink)
)

const omegaClient = new ApolloClient({
  link,
  cache: new InMemoryCache()
})

const { BaseLayer } = LayersControl
const tileProviders = [
  {
    id: 1,
    name: 'Humanitarian OSM',
    visible: true,
    url: 'https://tiles.tag-ip.com/osm_hot/{z}/{x}/{y}.png'
  },
  {
    id: 2,
    name: 'Openstreetmap',
    visible: false,
    url: 'https://tiles.tag-ip.com/osm_carto/{z}/{x}/{y}.png'
  },
  {
    id: 3,
    name: 'OSM Black & White',
    visible: false,
    url: 'https://tiles.tag-ip.com/osm_bw/{z}/{x}/{y}.png'
  }
]

class PositionComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      trackableStatus: props.trackableStatus
    }
  }

  componentWillReceiveProps (nextProps) {
    // Update state when trackableStatus prop changes (from polling)
    if (nextProps.trackableStatus !== this.props.trackableStatus) {
      this.setState({
        trackableStatus: nextProps.trackableStatus
      })
    }
  }

  componentDidUpdate (prevProps, prevState) {
    // Update map view when coordinates change
    if (prevState.trackableStatus !== this.state.trackableStatus) {
      const { latitude, longitude } = this.state.trackableStatus
      if (this.refs.map && this.refs.map.leafletElement) {
        this.refs.map.leafletElement.setView([latitude, longitude], 17)
      }
    }
  }

  // componentDidMount () {
  //   this.props.subscribeToMore({
  //     document: STATUS_BY_VEHICLE_UPDATED,
  //     variables: { id: this.props.trackableId },
  //     client: { omegaClient },
  //     updateQuery: (prev, {
  //       subscriptionData
  //     }) => {
  //       if (!subscriptionData.data) {
  //         return prev
  //       } else {
  //         this.setState({
  //           trackableStatus: subscriptionData.data.trackable_status_update
  //         })
  //         return {
  //           trackableStatus: subscriptionData.data.trackable_status_update
  //         }
  //       }
  //     }
  //   })
  // }

  getTileProviderRender () {
    const tileProvidersRender = tileProviders.map((tileProvider) => {
      return (
        <BaseLayer name={tileProvider.name} checked={tileProvider.visible} key={tileProvider.id}>
          <TileLayer
            url={tileProvider.url}
          />
        </BaseLayer>
      )
    })
    return tileProvidersRender
  }

  render () {
    let trackableStatus = this.state.trackableStatus
    return (
      <div>
        <div style={styles.paper}>
          <LinesEllipsis
            style={styles.title}
            text='LOCALISATION'
            maxLine='1'
            ellipsis='...'
            trimRight
            basedOn='letters'
          />
          <div style={styles.contentMap}>
            <div id='map' style={styles.map}>
              <Map
                ref='map'
                center={[trackableStatus.latitude, trackableStatus.longitude]} zoom={17}
                zoomControl={false}
                minZoom={1}
                maxZoom={18}
              >
                <LayersControl position='bottomleft'>
                  { this.getTileProviderRender() }
                </LayersControl>
                <Marker
                  position={[trackableStatus.latitude, trackableStatus.longitude]}
                  icon={
                    L.icon(
                      {
                        iconUrl: `${mapMarker}`,
                        iconSize: [20, 20],
                        iconAnchor: [10, 10]
                      }
                    )} />
              </Map>
            </div>
          </div>
          <div style={styles.containerLabel}>
            <div style={styles.contentLabel}>
              <span style={styles.place}>{trackableStatus.reverse_geocoding !== null ? trackableStatus.reverse_geocoding.display_name : '-'}</span><br />
              <span style={styles.state}>
                {trackableStatus.metadata.movement === 'moving'
                  ? 'En mouvement'
                  : "À l'arrêt"
                }
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  paper: {
    textAlign: 'left',
    backgroundColor: '#374147',
    height: '380px',
    borderRadius: '16px',
    paddingTop: '12px'
  },
  title: {
    marginLeft: '24px',
    marginTop: '6px',
    fontSize: '14px',
    fontWeight: 'bold',
    color: '#FFFFFF'
  },
  contentMap: {
    height: '108px',
    width: '100%'
  },
  map: {
    marginLeft: '24px',
    marginRight: '24px',
    marginTop: '68px',
    height: '150px',
    borderRadius: '2px',
    border: 'none'
  },
  containerLabel: {
    marginTop: '62px',
    height: '78px',
    width: '100%'
  },
  contentLabel: {
    marginLeft: '24px',
    marginRight: '24px',
    marginTop: '20px',
    height: '82px'
  },
  place: {
    float: 'left',
    color: '#A6B9C8',
    fontSize: '12px',
    fontWeight: 700
  },
  state: {
    float: 'left',
    color: '#6F808B',
    fontSize: '12px',
    fontWeight: 600
  },
  buttonContent: {
    width: '100%',
    marginTop: '17px',
    float: 'right',
    height: '34px'
  },
  button: {
    cursor: 'pointer',
    float: 'right',
    marginTop: '4px',
    width: '120px',
    height: '29px',
    border: 'none',
    backgroundColor: 'transparent'
  },
  label: {
    textAlign: 'right',
    color: '#7ED321',
    marginRight: '-4px',
    fontSize: '13px',
    fontWeight: 600
  },
  icon: {
    marginTop: '4px',
    marginRight: '-8px',
    float: 'right'
  }
}

export default PositionComponent
